import { createContext, useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { Navigate, useParams } from 'react-router'
import { AppRoutes } from '../../app-routes'
import { DialogContextTypes } from '../../enums'
import { useDialogCtx } from '../../hooks/context-hooks'
import { getWorkshop } from '../../http'
import { clearAxiosFeatureValueHeader, setAxiosFeatureValueHeader } from '../../Http/featureHttp'
import { Queries } from '../../queries'
import { IWorkshop, IWorkshopUser } from '../../types/data-types'
import { Spinner } from '../Common/Spinner'

export const WorkshopLayoutContext = createContext<{
  workshop: IWorkshop
  permission: number
  clientFeatureValue: bigint
  workshopUsers: IWorkshopUser[]
  loggedInWorkshopUserId?: number
}>(undefined)

export const WorkshopLayoutContextProvider = ({ children }) => {
  const { id: workshopId } = useParams<any>()
  const { data: workshop, isError } = useQuery([Queries.WORKSHOP, workshopId], () => getWorkshop(workshopId))
  const { getDialogs } = useDialogCtx()
  const [providerValue, setProviderValue] = useState(null)

  useEffect(() => {
    return () => {
      clearAxiosFeatureValueHeader()
    }
  }, [])

  useEffect(() => {
    if (workshop) {
      setProviderValue({
        workshop: workshop?.workshop,
        permission: workshop?.permissionValue,
        clientFeatureValue: BigInt(workshop?.clientFeatureValue),
        workshopUsers: workshop?.users || [],
        loggedInWorkshopUserId: workshop?.loggedInWorkshopUserId,
      })
      setAxiosFeatureValueHeader(workshop?.encryptedClientFeatureValue)
    }
  }, [workshop])

  if (isError) return <Navigate to={AppRoutes.NOT_FOUND} />

  return (
    <WorkshopLayoutContext.Provider value={providerValue}>
      {Object.values(getDialogs(DialogContextTypes.workshop) ?? {})}
      {!providerValue ? <Spinner /> : children}
    </WorkshopLayoutContext.Provider>
  )
}
